
import React from 'react';

const About: React.FC = () => {
  return (
    <section id="about" className="py-20">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-pixel mb-8 inline-block relative">
          <span className="text-shadow-glow">{'\u003E'} About</span>
          <span className="absolute -bottom-2 left-0 w-full h-0.5 bg-cyber-green"></span>
        </h2>
        
        <div className="cyber-box">
          <span></span>
          <div className="font-cyber">
            <h3 className="text-xl font-bold mb-4 text-cyber-green">Internet Voyageur</h3>
            <p className="mb-4">
              Welcome! I'm glad you've stopped by to explore specialagenk.eth. As someone who has journeyed through the Internet's evolution—from text-based bulletin boards to the cutting edge of Web3—I've seen firsthand how technology can reshape the ways we connect and collaborate.
            </p>
            <p className="mb-4">
              Blockchain, in my view, is more than just a platform for financial transactions. It holds the potential to revolutionize how people who don't fully trust each other can do business, share information, and form agreements.
            </p>
            <p className="mb-4">
              This website is my laboratory, where I jot down experiments, insights, and musings on the latest technological trends. Some are more serious than others, but I'm always curious to see which innovations will thrive in the long run, despite the market's inevitable ups and downs.
            </p>
            <p>
              I invite you to join me on this exploration—let's see what the future holds together.
            </p>
          </div>
          <span></span>
        </div>
      </div>
    </section>
  );
};

export default About;
